import { lazy, Suspense } from 'react';

import { Navigate, type RouteObject } from 'react-router-dom';

import { SplashScreen } from '@tankef/ui';

const OAuthCallbackPage = lazy(() =>
  import('@/domains/identity/oauth/routes').then(m => ({ default: m.OAuthCallbackPage }))
);
const TermsGatePage = lazy(() =>
  import('@/domains/identity/auth/routes').then(m => ({ default: m.TermsGatePage }))
);
const TermsPage = lazy(() =>
  import('@/domains/identity/auth/routes').then(m => ({ default: m.TermsPage }))
);
const PrivacyPage = lazy(() =>
  import('@/domains/identity/auth/routes').then(m => ({ default: m.PrivacyPage }))
);

export function standaloneRoutes(): RouteObject[] {
  return [
    {
      path: '/oauth/callback',
      element: (
        <Suspense fallback={<SplashScreen />}>
          <OAuthCallbackPage />
        </Suspense>
      ),
    },
    {
      path: '/auth/callback',
      element: (
        <Suspense fallback={<SplashScreen />}>
          <OAuthCallbackPage />
        </Suspense>
      ),
    },
    { path: '/', element: <Navigate to="/login" replace /> },
    {
      path: '/terms-gate',
      element: (
        <Suspense fallback={<SplashScreen />}>
          <TermsGatePage />
        </Suspense>
      ),
    },
    {
      path: '/terms',
      element: (
        <Suspense fallback={<SplashScreen />}>
          <TermsPage />
        </Suspense>
      ),
    },
    {
      path: '/privacy',
      element: (
        <Suspense fallback={<SplashScreen />}>
          <PrivacyPage />
        </Suspense>
      ),
    },
    { path: '*', element: <Navigate to="/dashboard" replace /> },
  ];
}
